import { render, staticRenderFns } from "./save-translations.vue?vue&type=template&id=1ec6ec54&"
import script from "./save-translations.vue?vue&type=script&lang=js&"
export * from "./save-translations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Cristi\\Documents\\Work\\www\\tpdemo\\wp-content\\plugins\\translatepress\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1ec6ec54', component.options)
    } else {
      api.reload('1ec6ec54', component.options)
    }
    module.hot.accept("./save-translations.vue?vue&type=template&id=1ec6ec54&", function () {
      api.rerender('1ec6ec54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/src/js/components/save-translations.vue"
export default component.exports